<script>
import Toolbar from 'primevue/toolbar';
import Dialog from 'primevue/dialog';

import CommonConstants from '../../common/Constants';
import Fieldset from 'primevue/fieldset';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Calendar from 'primevue/calendar';
import GenericBooleanDropdown from '../generic/GenericBooleanDropdown.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
// import LabelField from '../../components/generic/LabelField.vue'
import VesselNominationLotDialogApplyAll from '@/components/movement-instruction/VesselNominationLotDialogApplyAll.vue';

import { required, helpers  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '../../services/movement-instruction';
import Utils from '../../common/Utils';
import GenericDataTable from '../generic/GenericDataTable.vue'
import config from '../../common/genericPanelConf';


const isMovementDirectionOut = helpers.withMessage('Value is required', function(el){
    if(this.visibilityData.movementDirection == CommonConstants.movementDirection.OUT){
        return el != null;
    }
    return true;
});

const quantityNotNull = helpers.withMessage('', function(el){
  return el != null;
})

const checkQuantities = helpers.withMessage('movementInstructions.messages.minMaxQuantityValidation', function(el){
  let minq = this.data.minimumQuantity ?? 0;
  let maxq = this.data.maximumQuantity ?? 0;
  if(minq > maxq){
    return false;
  }
  return true;
});

// const isNotTransferStock = helpers.withMessage('Value is required', function(el){
//     if(this.visibilityData.transportType != CommonConstants.transportType.STOCK_TRANSFER){
//         return el != null;
//     }
//     return true;
// });

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar, Dialog, GenericDataTable,
    Fieldset, InputText, InputNumber, Textarea, Calendar, 
    GenericCustomMasterDataAutocompleteV2,
    //LabelField,
    ResponsiveButton, GenericBooleanDropdown,VesselNominationLotDialogApplyAll
  },
  props: ['id', 'movementInstructionId', 'readOnly', 'refreshLots', 'visibilityData', 'headerData', 'defaultData', 'proposal'],
  emits: ['updateLotDetail', 'setReadOnly', 'checkMovementInstructionToBeAssociated'],
   data(){
    return {
      data: {},
      submitted: false,
      fiscalInfoVisible: false,
      searchTaxWarehouseDialogVisible: false,
      taxWarehouseConfiguration: {},
      taxWarehouseDialogFilters: {
        consigneeExciseCode: null,
        consigneeName: null,
        placeOfDeliveryExciseCode: null,
        placeOfDeliveryName: null
      },
      companiesApi: '',
      counterpartiesApi: '',
        proposalText: "",
        proposalField: null,
        proposalIsPort: false,
        proposalEadConsignee: null,
        proposalEadPlaceOfDelivery: null,
        vesselNominationApproveDialogVisible: false,
        disableDestPortAuto: false,
        proposalDate: null
    }
   },
    validations(){
    return {
      data: {
        idCompany: { required },
        idCounterparty: {},
        idContractType: {},
        contractDate: {},
        charterPartyDated: {},
        contractNumberReference: {},
        idRegistryInspectionCost: {},
        shipper: { isMovementDirectionOut },
        deliveryDocumentHolder: { isMovementDirectionOut },
        billofLadingHolder: {},
        notifyAddress: {},
        analysisDocumentLanguageCode: {},
        documentLanguageCode: {},
        incotermCode: {},

        idOriginCountry: {},
        idPlaceOfLoading: {},
        idPortOrLocationOfLoading: {},

        idDestinationCountry: {},
        idPlaceOfDischarge: {},
        idPortOrLocationOfDischarge: {},

        // originCountryCode: {},
        // placeOfLoadingCode: {},
        // portOrLocationofLoadingCode: {},
        // destinationCountryCode: {},
        // placeofDischargeCode: {},
        // portOrLocationofDischargeCode: {},

        idRegistryProduct: { required },
        quantity: { quantityNotNull },
        minimumQuantity: { quantityNotNull, checkQuantities },
        maximumQuantity: { quantityNotNull, checkQuantities },
        quantityUoMCode: { required },
        productTradeDescription: { required },
        typeMovementInstructionLotCode: { required },
        idRegistryCustomSituation: {},
        idRegistryFiscalPosition: {},
        idRegistryFiscalUse: {},
        idRegistryEnergyProductDetail: {},
        placeofFiscalDestinationDescription: {},
        portorLocationofFiscalDestinationDescription: {},
        idDestinationTaxWarehouse: {},
        isOutCDep: {},
        isFip: { required }
      }
    }
  },
  mounted(){
    if(this.defaultData){
      this.data = {...this.defaultData}
    }
    this.loadInfo();
    this.refreshCompaniesCombo();
    // this.companiesApi = `movement-instruction/companies-by-operation-combo?referenceDate=${Utils.formatDateForAPI(this.headerData.laycanStartDate)}&isCounterparty=false&idRegistryOperationType=${this.headerData.idOperationType}`;
    // this.counterpartiesApi = `movement-instruction/companies-by-operation-combo?referenceDate=${Utils.formatDateForAPI(this.headerData.laycanStartDate)}&isCounterparty=true&idRegistryOperationType=${this.headerData.idOperationType}`;
        
    this.taxWarehouseConfiguration = config.getConfiguration('TaxWarehouseMovementInstruction');
  },
  computed: {
      constants(){
        return CommonConstants;
      },
      utils(){
        return Utils;
      },
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      },
      // companiesApi(){
      //   return `movement-instruction/companies-by-operation-combo?referenceDate=${Utils.formatDateForAPI(this.headerData.laycanStartDate)}&isCounterparty=false&idRegistryOperationType=${this.headerData.idOperationType}`;
      // },
      // counterpartiesApi(){
      //   return `movement-instruction/companies-by-operation-combo?referenceDate=${Utils.formatDateForAPI(this.headerData.laycanStartDate)}&isCounterparty=true&idRegistryOperationType=${this.headerData.idOperationType}`;
      // },
      ncApi(){
        if(this.data.idRegistryProduct){
          return `masterdata/energy-product-detail-combonc?idProduct=${this.data.idRegistryProduct}&transportType=${this.visibilityData.transportType}`;
        }
        return null;
      },
      lotProposal(){
        if(this.proposal && this.proposal.parcels && this.proposal.parcels.length > 0){
          return this.proposal.parcels.find(x => x.movementInstructionLotCode == this.data.lotCode);
        }
        return {};
      },
      inpectionCostApi(){
        return this.readOnly ? 'masterdata/inspection-cost-combo' : 'masterdata/inspection-cost-combo?getOnlyValid=true'
      }
  },
  methods: {
    loadInfo(){
      if(this.id){
        Service.getLot(this.id, response => {
            if(response.success){
              response.data.contractDate = response.data.contractDate ? Utils.dateToCurrentTimeZone(response.data.contractDate) : null;
              response.data.charterPartyDated = response.data.charterPartyDated ? Utils.dateToCurrentTimeZone(response.data.charterPartyDated) : null;
              this.data = response.data;

              if(this.$refs.ncCombo){
                this.$refs.ncCombo.forceLoadOptions(this.ncApi);
              }
            }
        });
      }
    },
    save(valid){
      this.submitted = true;


      if (!valid){
          return;
      }

      this.submitted = false;

      if(this.id){
        this.$store.dispatch("generic/setLoading", true);
        Service.saveLotMain(this.data, 
          response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
              this.refreshLots();
              // this.loadInfo();
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              this.$emit('checkMovementInstructionToBeAssociated');
            }else{
              this.loadInfo();
              this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:4000, severity:'error'});
            }
          }
        );
      }else{
              this.$store.dispatch("generic/setLoading", true);
        this.data.idMovementInstructionHeader = this.movementInstructionId;
        Service.createLot(this.data, 
          response => {
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
              this.$emit('setReadOnly');
              this.refreshLots();
              // this.loadInfo();
              this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              this.$emit('checkMovementInstructionToBeAssociated');
            }else{
              this.$toast.add({detail: response.message && response.message != '' ? this.$t(response.message) :  this.$t('messages.generic_error_message'), life:4000, severity:'error'});
            }
          }
        );
      }
    },
    onCompanyChange(el){
      if (!this.readOnly) {
        this.data.shipper = el.extraData.shipperDescription;

        if(this.data.idCounterparty == null){
          this.data.billofLadingHolder = el.extraData.billOfLadingHolderDescription;
          this.data.deliveryDocumentHolder = el.extraData.deliveryDocumentHolderDescription;
        }
      }
    },
    onCounterpartyChange(el){
      if (!this.readOnly) {
        this.data.billofLadingHolder = el.extraData.billOfLadingHolderDescription;
        this.data.deliveryDocumentHolder = el.extraData.deliveryDocumentHolderDescription;
      }
    },
    setIsOutCDep() {
      if (!this.readOnly) {
        Service.configIsOutCDep({
          idRegistryOperationType: this.headerData.idOperationType,
          idRegistryCompany: this.data.idCompany,
          idRegistryCounterparty: this.data.idCounterparty,
          date: Utils.formatDateForAPI(this.headerData.laycanStartDate)
        }, ({success, data}) => {
          if(success) {
            this.data.isOutCDep = data;
          }
        })
      }
    },
    setIsFip() {
      if (!this.readOnly) {
        Service.checkIsFip({
          idOperationType: this.headerData.idOperationType,
          idCompany: this.data.idCompany,
          idProduct: this.data.idRegistryProduct,
        }, ({success, data}) => {
          if(success) {
            this.data.isFip = data;
          }
        })
      }
    },   
    onProductChange(el){
      if (!this.readOnly) {
        this.data.productTradeDescription = el.extraData.englishDescription;
        if(el.extraData.idOriginCountry){
          this.data.idOriginCountry = el.extraData.idOriginCountry;
        }
      }
    },
    onPortOrLocationOfDischargeChange(el){
      if (!this.readOnly) {

        let d = el.extraData.name.toUpperCase();
        if(el.extraData.countryAndTerritory){
          d = d + ', ' + el.extraData.countryAndTerritory.toUpperCase();
        }
        if(!this.disableDestPortAuto){
          this.data.portorLocationofFiscalDestinationDescription = d;
        }
        this.disableDestPortAuto = false;
        this.data.idDestinationCountry = el.extraData.countryAndTerritoryId;
        this.data.idPlaceOfDischarge = el.extraData.countryAndTerritoryId;
      }
    },
    onPlaceOfDischargeChange(el){
      this.data.placeofFiscalDestinationDescription = el.label.toUpperCase();
      this.data.idFiscalDestination = el.extraData.idFiscalDestination;
      this.data.fiscalDestination = el.extraData.fiscalDestinationDescription;
      this.data.fiscalDestinationCode = el.extraData.fiscalDestinationShortDescription;
      if(this.data.fiscalDestinationCode == 'EST'){
        this.data.idDestinationTaxWarehouse = null;
      }else{
        console.log('ITA')
      }
    }, 
    checkLotType(){
      if(this.data.quantity != null && this.data.minimumQuantity != null && this.data.maximumQuantity != null ){
        if(this.data.quantity == this.data.minimumQuantity && this.data.quantity == this.data.maximumQuantity){
          this.data.typeMovementInstructionLotCode = 'F';
        }else{
          this.data.typeMovementInstructionLotCode = 'B';
        }
      }else{
          this.data.typeMovementInstructionLotCode = null;
      }
    },
    toggleTaxWarehouseSearch(){
      this.searchTaxWarehouseDialogVisible = !this.searchTaxWarehouseDialogVisible;
    },
    onTaxWarehouseSelected(record){
      this.data.idDestinationTaxWarehouse = record.id;
      this.data.destinationTaxWarehouse = `${record.consigneeExciseCode} ${record.consigneeName}`;
      this.searchTaxWarehouseDialogVisible = false;
    },
    clearTaxWarehouse(){
      this.data.idDestinationTaxWarehouse = null;
      this.data.destinationTaxWarehouse = null;
    },
    taxWarehouseSearch(){
      let filters = [];
      if(this.taxWarehouseDialogFilters.consigneeExciseCode){
        filters.push({
          operator: 'like',
          value: this.taxWarehouseDialogFilters.consigneeExciseCode,
          property: 'ConsigneeExciseCode'
        });
      }
      if(this.taxWarehouseDialogFilters.consigneeName){
        filters.push({
          operator: 'like',
          value: this.taxWarehouseDialogFilters.consigneeName,
          property: 'ConsigneeName'
        });
      }
      if(this.taxWarehouseDialogFilters.placeOfDeliveryExciseCode){
        filters.push({
          operator: 'like',
          value: this.taxWarehouseDialogFilters.placeOfDeliveryExciseCode,
          property: 'PlaceOfDeliveryExciseCode'
        });
      }
      if(this.taxWarehouseDialogFilters.placeOfDeliveryName){
        filters.push({
          operator: 'like',
          value: this.taxWarehouseDialogFilters.placeOfDeliveryName,
          property: 'PlaceOfDeliveryName'
        });
      }

      filters.push({
        operator: '=',
        value: false,
        property: 'IsDeleted'
      });

      filters.push({
        operator: '=',
        value: true,
        property: 'IsEnabled'
      });

      this.$refs.taxWarehouseGrid.filterFromView(filters);
    },
    refreshCompaniesCombo(){
      if(this.headerData.idOperationType && this.$refs.companiesCombo && this.$refs.counterpartiesCombo){
        this.companiesApi = `movement-instruction/companies-by-operation-combo?referenceDate=${Utils.formatDateForAPI(this.headerData.laycanStartDate)}&isCounterparty=false&idRegistryOperationType=${this.headerData.idOperationType}`;
        this.$refs.companiesCombo.forceLoadOptions(this.companiesApi);

        this.counterpartiesApi = `movement-instruction/companies-by-operation-combo?referenceDate=${Utils.formatDateForAPI(this.headerData.laycanStartDate)}&isCounterparty=true&idRegistryOperationType=${this.headerData.idOperationType}`;
        this.$refs.counterpartiesCombo.forceLoadOptions(this.counterpartiesApi);
      }
    },
    openProposal(e, field, type, lot){
      this.proposalField = null;
      switch(field){
        case 'incoterm':
        case 'consignee':
        case 'notifyAddress':
        case 'product':
        case 'quantity':
        case 'charterPartyDated':
        this.proposalField = field;
        break;
          case 'eadConsignee':
          this.proposalEadConsignee = this.lotProposal.eadConsignee?.replaceAll(' ', '');
          this.proposalEadPlaceOfDelivery = this.lotProposal.eadPlaceOfDelivery?.replaceAll(' ', '');
          this.proposalField = field;
        break;
        case 'portOfDischarge':
          if(type){
            this.proposalField = field;
          }
        break;
      }
      let v = (lot) ? this.lotProposal[field] : this.proposal[field];
      if(type == 'port'){
        v = this.lotProposal[field].split(" ")[0].replace(",", "").replace(".", "").replace("-", "");
        this.proposalIsPort = true;
      }else{
        this.proposalIsPort = false;
      }
      if(type == 'date'){
        v = Utils.formatDateTime(Utils.dateToCurrentTimeZone((lot) ? this.lotProposal[field] : this.proposal[field]));
      }
      if(type == 'dateOnly'){
        v = Utils.formatDate((lot) ? this.lotProposal[field] : this.proposal[field], "DD.MM.yyyy");
        this.proposalDate = Utils.dateToCurrentTimeZone(this.lotProposal[field]);
      }
      if(field == 'eadConsignee'){
        if(this.lotProposal.eadConsignee && this.lotProposal.eadPlaceOfDelivery){
          v = `${this.$t('VesselNomination.parcel.eadConsignee')}:${this.lotProposal.eadConsignee}, ${this.$t('VesselNomination.parcel.eadPlaceOfDelivery')}:${this.lotProposal.eadPlaceOfDelivery}`;
        }else if(this.lotProposal.eadConsignee){
          v = `${this.$t('VesselNomination.parcel.eadConsignee')}:${this.lotProposal.eadConsignee}`;
        }else{
          v = `${this.$t('VesselNomination.parcel.eadPlaceOfDelivery')}:${this.lotProposal.eadPlaceOfDelivery}`;
        }
      }

      let message = v;
      this.proposalText = message;
      this.$refs.proposalop.toggle(e);
    },
    applyProposalText(){
      switch(this.proposalField){
        case 'incoterm':
          this.$refs.incontermCombo.queryFilterWithDefault(this.proposalText)
          break;
        case 'consignee':
          this.data.billofLadingHolder = this.proposalText;
          break;
        case 'notifyAddress':
          this.data.notifyAddress = this.proposalText;
          break;
        case 'product':
          this.data.productTradeDescription = this.proposalText;
        break;
        case 'eadConsignee':
          this.toggleTaxWarehouseSearchProposal();
        break;
        case 'portOfDischarge':
          if(this.proposalIsPort){
            this.$refs.portOfLocationOfDischargeCombo.queryFilterWithDefault(this.proposalText)
          }else{
            this.data.portorLocationofFiscalDestinationDescription = this.proposalText;

          }
        break;
        case 'quantity':
          this.data.quantity = this.lotProposal.quantityParsed;
          if(this.data.minimumQuantity > this.data.quantity){
            this.data.minimumQuantity = this.lotProposal.quantityParsed;
          }

          if(this.data.maximumQuantity < this.data.quantity){
            this.data.maximumQuantity = this.lotProposal.quantityParsed;
          }
        break;
        case 'charterPartyDated':
          this.data.charterPartyDated = this.proposalDate;
          break;
      }

    },
    
    applyAllProposal(obj){
      if(obj.incotermApply){
        this.data.incotermCode = obj.incotermCode;
      }
      if(obj.billofLadingHolderApply){
        this.data.billofLadingHolder = obj.billofLadingHolder;
      }
      if(obj.notifyAddressApply){
        this.data.notifyAddress = obj.notifyAddress;
      }
      if(obj.charterPartyDated){
        this.data.charterPartyDated = obj.charterPartyDated;
      }
      if(obj.productTradeDescriptionApply){
        this.data.productTradeDescription = obj.productTradeDescription;
      }
      if(obj.idPortOrLocationOfDischargeApply){
        this.disableDestPortAuto = true;
        this.data.portorLocationofFiscalDestinationDescription = obj.portorLocationofFiscalDestinationDescription;
        this.data.idPortOrLocationOfDischarge = obj.idPortOrLocationOfDischarge;
        this.data.portOrLocationOfDischarge = obj.portOrLocationOfDischarge
      }

      if(obj.quantityParsedApply){
        this.data.quantity = obj.quantityParsed;
        if(this.data.minimumQuantity > this.data.quantity){
          this.data.minimumQuantity = obj.quantityParsed;
        }

        if(this.data.maximumQuantity < this.data.quantity){
          this.data.maximumQuantity = obj.quantityParsed;
        }
      }

      if(obj.idDestinationTaxWarehouseApply){
        this.data.destinationTaxWarehouse = obj.destinationTaxWarehouseLabel;
        this.data.idDestinationTaxWarehouse = obj.idDestinationTaxWarehouse;
      }
      this.vesselNominationApproveDialogVisible = false;
    },
    toggleTaxWarehouseSearchProposal(){
      this.taxWarehouseDialogFilters.consigneeExciseCode = this.proposalEadConsignee
      this.taxWarehouseDialogFilters.placeOfDeliveryExciseCode = this.proposalEadPlaceOfDelivery
      
      this.searchTaxWarehouseDialogVisible = true;
      const delay = ms => new Promise(res => setTimeout(res, ms));
      const launchSearch = async () => {
        await delay(1000);
        this.taxWarehouseSearch()
      };
      launchSearch();
    },
    checkModifiedField(field){
      if(field == 'incoterm'){
        return this.proposal && this.proposal.modifiedFieldList && this.proposal.modifiedFieldList.length > 0 && this.proposal.modifiedFieldList.includes(field)
      }else{
        return this.proposal && this.lotProposal &&  this.lotProposal.modifiedFieldList && this.lotProposal.modifiedFieldList.length > 0 && this.lotProposal.modifiedFieldList.includes(field);
      }
    },
    openProposalApplyAllRecords(){
      this.vesselNominationApproveDialogVisible = true;
    }
  },
  watch: {
    'headerData.idOperationType'(){
      this.refreshCompaniesCombo();
      this.setIsOutCDep();
    },
    'headerData.laycanStartDate'(){
      this.refreshCompaniesCombo();      
    },
    'headerData.showIsFip'(){
      this.setIsFip();
    },
    'data.idCompany'(){
      this.setIsOutCDep();
      this.setIsFip();
    },
    'data.idCounterparty'(){
      this.setIsOutCDep();
    },
    'data.quantity'(){
      this.checkLotType();
    },
    'data.minimumQuantity'(){
      this.checkLotType();
    },
    'data.maximumQuantity'(){
      this.checkLotType();
    },
    'data.idRegistryProduct'(newValue, oldValue){
      if(newValue && newValue != oldValue){
        if(this.$refs.ncCombo){
          this.$refs.ncCombo.forceLoadOptions(this.ncApi);
        }
      }
      this.setIsFip();
      this.$emit('updateLotDetail', this.id, 'idRegistryProduct', this.data.idRegistryProduct);
    },
    readOnly(){
      this.$refs.inspectionCostCombo.forceLoadOptions(this.inpectionCostApi);
    }
  }
}

</script>

<template>
  <main>
    <OverlayPanel ref="proposalop">
      <p>Il campo suggerito dall'ultima comunicazione via e-mail è: {{ proposalText }}</p>
        <Toolbar v-if="!readOnly && proposalField">
          <template #end>
            <ResponsiveButton :label="$t('btn.apply')" class="p-button-outlined p-button-sm m-1" @click="applyProposalText"  />
          </template>
        </Toolbar>
    </OverlayPanel>
      <Dialog header=" " v-model:visible="searchTaxWarehouseDialogVisible" :style="{width: '75vw'}" :modal="true">
        <div class="grid">
          <div class="col-12 lg:col-3 field">
            <label>{{$t('taxWarehouse.consigneeExciseCode')}}</label>
            <InputText type="text" v-model="taxWarehouseDialogFilters.consigneeExciseCode" class="w-full p-inputtext-sm mt-1" />
          </div>
          <div class="col-12 lg:col-3 field">
            <label>{{$t('taxWarehouse.consigneeName')}}</label>
            <InputText type="text" v-model="taxWarehouseDialogFilters.consigneeName" class="w-full p-inputtext-sm mt-1" />
          </div>
          <div class="col-12 lg:col-3 field">
            <label>{{$t('taxWarehouse.placeOfDeliveryExciseCode')}}</label>
            <InputText type="text" v-model="taxWarehouseDialogFilters.placeOfDeliveryExciseCode" class="w-full p-inputtext-sm mt-1" />
          </div>
          <div class="col-12 lg:col-3 field">
            <label>{{$t('taxWarehouse.placeOfDeliveryName')}}</label>
            <InputText type="text" v-model="taxWarehouseDialogFilters.placeOfDeliveryName" class="w-full p-inputtext-sm mt-1" />
          </div>
        </div>
        <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" @click="taxWarehouseSearch" class="p-button-outlined p-button-sm" />
        <generic-data-table :configuration="taxWarehouseConfiguration" :category="'movement-instruction'" :name="'tax-warehouse'" ref="taxWarehouseGrid" @on-tax-warehouse-selected="onTaxWarehouseSelected" />
      </Dialog>
      <Toolbar style="padding: 0;">
        <template #start>
            <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="p-button-outlined p-button-sm" @click="save((!v$.$invalid))" v-if="!readOnly" :disabled="!uiPermissions('movementInstructionEditButton').isEnabled || readOnly"/>
        </template>
      </Toolbar>
      
    <Dialog v-model:visible="vesselNominationApproveDialogVisible" :modal="true" :closable="true" :style="{width: '80vw'}">
        <VesselNominationLotDialogApplyAll :proposal="proposal" :lotProposal="lotProposal" :actual="data" @applyProposal="applyAllProposal" />
    </Dialog>
      <div class="grid">
        <div class="col-12">
          <div class="card">
          <ResponsiveButton :label="$t('VesselNomination.page_title')" icon="fa-solid fa-robot" class="p-button-outlined p-button-sm" @click="openProposalApplyAllRecords" v-if="!readOnly && proposal && lotProposal" :disabled="!uiPermissions('movementInstructionEditButton').isEnabled" />
          <Fieldset class="col-12" :legend="$t('movementInstructions.lotHeader')">
              <div class="grid formgrid" >
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="idCompany" :class="{'p-error':v$.data.idCompany.$invalid && submitted}">{{$t('company.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idCompany"
                      :disableStore="true"
                      :compileIfOnly="true"
                      :changeFn="onCompanyChange"
                      :disabled="readOnly"
                      name="companies"
                      :api="companiesApi"
                      ref="companiesCombo"
                      :class="{'p-invalid':v$.data.idCompany.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.data.idCompany.$invalid && submitted) || v$.data.idCompany.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.idCompany.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  <!-- </span> -->
                  <!-- <span v-else>
                    <LabelField :value="data.company" :label="$t('company.fk')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="idCounterparty" :class="{'p-error':v$.data.idCounterparty.$invalid && submitted}">{{$t('counterparty')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idCounterparty"
                      :disableStore="true"
                      :compileIfOnly="true"
                      :disabled="readOnly"
                      :changeFn="onCounterpartyChange"
                      name="counterparties"
                      :api="counterpartiesApi"
                      ref="counterpartiesCombo"
                      :class="{'p-invalid':v$.data.idCounterparty.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.counterparty" :label="$t('counterparty')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <label for="isOutCDep" :class="{'p-error':v$.data.isOutCDep.$invalid && submitted}">{{$t('movementInstructions.isOutCDep')}}</label>
                    <GenericBooleanDropdown
                      id="isOutCDep" 
                      :disabled="readOnly"
                      v-model="data.isOutCDep" 
                      :class="{'p-invalid':v$.data.isOutCDep.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                </div>
                <div class="col-12 lg:col-3 field" v-if="headerData.showIsFip">
                  <label for="isFip" :class="{'p-error':v$.data.isFip.$invalid && submitted}">{{$t('movementInstructions.isFip')}}</label>
                    <GenericBooleanDropdown
                      id="isFip" 
                      :disabled="readOnly"
                      v-model="data.isFip" 
                      :class="{'p-invalid':v$.data.isFip.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="idContractType" :class="{'p-error':v$.data.idContractType.$invalid && submitted}">{{$t('contractType.fk')}}</label>
                       <GenericCustomMasterDataAutocompleteV2
                        v-model="data.idContractType"
                        :updateModel="data" 
                        updateField="idContractType"  
                        :disabled="readOnly"
                        name="contract-types" 
                        api="masterdata/contract-type-combo"
                        :class="{'p-invalid':v$.data.idContractType.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.contractType" :label="$t('contractType.fk')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="contractDate" :class="{'p-error':v$.data.contractDate.$invalid && submitted}">{{$t('movementInstructions.contractDate')}}</label>
                    <Calendar 
                    :disabled="readOnly"
                      id="contractDate" 
                      v-model="data.contractDate"
                      :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                      :dateFormat="constants.DATE_FORMAT"
                      :class="{'p-invalid':v$.data.contractDate.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.contractDate ? utils.formatDate(data.contractDate) : ''" :label="$t('movementInstructions.contractDate')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="contractNumberReference" :class="{'p-error':v$.data.contractNumberReference.$invalid && submitted}">{{$t('movementInstructions.contractNumber')}}</label>
                    <InputText 
                    :disabled="readOnly"
                      id="contractNumberReference" type="text" 
                      v-model="data.contractNumberReference" 
                      :class="{'p-invalid':v$.data.contractNumberReference.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.contractNumberReference" :label="$t('movementInstructions.contractNumber')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                    <label for="incoterm" :class="{'p-error':v$.data.incotermCode.$invalid && submitted}">{{$t('incoterm.fk')}}</label>
                  <div class="p-inputgroup">
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.incotermCode"
                      ref="incontermCombo"
                      :disabled="readOnly"
                      name="incoterms"
                      api="masterdata/incoterm-combo"
                      :class="{'p-invalid':v$.data.incotermCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'incoterm')" class="mt-1" :class="{'p-button-danger': checkModifiedField('incoterm'), 'p-button-success': !checkModifiedField('incoterm')}" v-if="proposal && proposal.incoterm"/>
                    </div>
                </div>
                <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType != constants.transportType.STOCK_TRANSFER">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="idRegistryInspectionCost" :class="{'p-error':v$.data.idRegistryInspectionCost.$invalid && submitted}">{{$t('inspectionCost.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idRegistryInspectionCost"
                    :disabled="readOnly"
                    name="inspection-costs" 
                      :api="inpectionCostApi"
                      :disableStore="true"
                      ref="inspectionCostCombo"
                      :class="{'p-invalid':v$.data.idRegistryInspectionCost.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.inspectionCost" :label="$t('inspectionCost.fk')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT && visibilityData.transportType != constants.transportType.STOCK_TRANSFER">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="shipper" :class="{'p-error':v$.data.shipper.$invalid && submitted}">{{$t('movementInstructions.shipper')}}</label>
                    <InputText 
                    :disabled="readOnly"
                      id="shipper" type="text" 
                      v-model="data.shipper" 
                      :class="{'p-invalid':v$.data.shipper.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.data.shipper.$invalid && submitted) || v$.data.shipper.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.shipper.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.shipper" :label="$t('movementInstructions.shipper')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="deliveryDocumentHolder" :class="{'p-error':v$.data.deliveryDocumentHolder.$invalid && submitted}">{{$t('movementInstructions.deliveryDocumentHolder')}}</label>
                    <InputText 
                    :disabled="readOnly"
                      id="deliveryDocumentHolder" type="text" 
                      v-model="data.deliveryDocumentHolder" 
                      :class="{'p-invalid':v$.data.deliveryDocumentHolder.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.data.deliveryDocumentHolder.$invalid && submitted) || v$.data.deliveryDocumentHolder.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.deliveryDocumentHolder.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.deliveryDocumentHolder" :label="$t('movementInstructions.deliveryDocumentHolder')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType != constants.transportType.STOCK_TRANSFER">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="documentLanguageCode" :class="{'p-error':v$.data.documentLanguageCode.$invalid && submitted}">{{$t('movementInstructions.documentLanguageCode')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.documentLanguageCode"
                      :disabled="readOnly"
                      name="languages" 
                      api="masterdata/language-combo"
                      :class="{'p-invalid':v$.data.documentLanguageCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.documentLanguageCode" :label="$t('movementInstructions.documentLanguageCode')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field" v-if="visibilityData.transportType != constants.transportType.STOCK_TRANSFER">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="analysisDocumentLanguageCode" :class="{'p-error':v$.data.analysisDocumentLanguageCode.$invalid && submitted}">{{$t('movementInstructions.analysisDocumentLanguageCode')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.analysisDocumentLanguageCode"
                    :disabled="readOnly"
                    name="languages" 
                      api="masterdata/language-combo"
                      :class="{'p-invalid':v$.data.analysisDocumentLanguageCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span> -->
                  <!-- <span v-else>
                    <LabelField :value="data.analysisDocumentLanguageCode" :label="$t('movementInstructions.analysisDocumentLanguageCode')"/>
                  </span> -->
                </div>
              </div>
            </Fieldset>
            
            <Fieldset class="col-12 mt-2" :legend="$t('movementInstructions.billOfLading')">
              <div class="grid formgrid">
                <div class="col-12 lg:col-3 field">
                    <label for="charterPartyDated" :class="{'p-error':v$.data.charterPartyDated.$invalid && submitted}">{{$t('movementInstructions.charterPartyDated')}}</label>
                    <div class="p-inputgroup">
                      <Calendar 
                        :disabled="readOnly"
                        id="charterPartyDated" 
                        v-model="data.charterPartyDated"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :dateFormat="constants.DATE_FORMAT"
                        :class="{'p-invalid':v$.data.charterPartyDated.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                      <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'charterPartyDated', 'dateOnly', true)" class="mt-1" :class="{'p-button-danger': checkModifiedField('charterPartyDated'), 'p-button-success': !checkModifiedField('charterPartyDated')}" v-if="lotProposal && lotProposal.charterPartyDated" />
                      <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'charterPartyDatedString', null, true)" class="mt-1" :class="{'p-button-danger': checkModifiedField('charterPartyDatedString'), 'p-button-success': !checkModifiedField('charterPartyDatedString')}" v-if="lotProposal && !lotProposal.charterPartyDated && lotProposal.charterPartyDatedString" />
                    </div>
                </div>
                <div class="col-12 lg:col-12 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                    <label for="billOfLadingHolder" :class="{'p-error':v$.data.billofLadingHolder.$invalid && submitted}">{{$t('movementInstructions.billOfLadingHolder')}}</label>
                    <div class="p-inputgroup">
                    <Textarea 
                    :disabled="readOnly"
                      id="billOfLadingHolder" 
                      v-model="data.billofLadingHolder" 
                      :class="{'p-invalid':v$.data.billofLadingHolder.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'consignee', null, true)" :class="{'p-button-danger': checkModifiedField('consignee'), 'p-button-success': !checkModifiedField('consignee')}"  v-if="lotProposal && lotProposal.consignee"/>
                    </div>
                </div>
                <div class="col-12 lg:col-12 field">
                    <label for="notifyAddress" :class="{'p-error':v$.data.notifyAddress.$invalid && submitted}">{{$t('movementInstructions.notifyCompleteAddress')}}</label>
                    <div class="p-inputgroup">
                      <Textarea :disabled="readOnly" id="notifyAddress" v-model="data.notifyAddress" 
                        :class="{'p-invalid':v$.data.notifyAddress.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}"/>
                        <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'notifyAddress', null, true)" :class="{'p-button-danger': checkModifiedField('notifyAddress'), 'p-button-success': !checkModifiedField('notifyAddress')}" v-if="lotProposal && lotProposal.notifyAddress"/>
                    </div>
                </div>
              </div>
            </Fieldset>
            
            <Fieldset class="col-12 mt-2" :legend="$t('movementInstructions.product')">
              <div class="grid formgrid" >
                <div class="col-12 lg:col-3 field">
                    <label for="typeMovementInstructionLotCode" :class="{'p-error':v$.data.typeMovementInstructionLotCode.$invalid && submitted}">{{$t('movementInstructions.typeMovementInstructionLotCode')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      name="typeMovementInstructionLotCode"
                      v-model="data.typeMovementInstructionLotCode"
                      ref="typeMovementInstructionLotCode"
                      :disabled="true"
                      api="masterdata/type-movement-instruction-lot-combo"
                      :class="{'p-invalid':v$.data.typeMovementInstructionLotCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.data.typeMovementInstructionLotCode.$invalid && submitted) || v$.data.typeMovementInstructionLotCode.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.typeMovementInstructionLotCode.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                </div>
                <div class="col-12 lg:col-3 field">
                    <label for="idRegistryProduct" :class="{'p-error':v$.data.idRegistryProduct.$invalid && submitted}">{{$t('product.fk')}}</label>
                      <GenericCustomMasterDataAutocompleteV2
                        v-model="data.idRegistryProduct"
                        :changeFn="onProductChange"
                        :disabled="readOnly"
                        name="products" 
                        api="masterdata/product-combo"
                        :class="{'p-invalid':v$.data.idRegistryProduct.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                       
                    <div v-if="(v$.data.idRegistryProduct.$invalid && submitted) || v$.data.idRegistryProduct.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.idRegistryProduct.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="productTradeDescription" :class="{'p-error':v$.data.productTradeDescription.$invalid && submitted}">{{$t('movementInstructions.productTradeDescription')}}</label>
                    <div class="p-inputgroup">
                    <InputText 
                      :disabled="readOnly"
                      id="productTradeDescription" type="text" 
                      v-model="data.productTradeDescription" 
                      :class="{'p-invalid':v$.data.productTradeDescription.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                      <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'product', null, true)" :class="{'p-button-danger': checkModifiedField('product'), 'p-button-success': !checkModifiedField('product')}" v-if="lotProposal && lotProposal.product"/>
                    </div>
                    <div v-if="(v$.data.productTradeDescription.$invalid && submitted) || v$.data.productTradeDescription.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.productTradeDescription.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.productTradeDescription" :label="$t('movementInstructions.productTradeDescription')"/>
                  </span> -->
                </div>
                </div>
                <div class="grid formgrid" >
                <div class="col-12 lg:col-3 field">
                    <label for="quantity" :class="{'p-error':v$.data.quantity.$invalid && submitted}">{{$t('movementInstructions.quantity')}}</label>
                    <div class="p-inputgroup">
                      <InputNumber 
                        :disabled="readOnly"
                        id="quantity" 
                        v-model="data.quantity"
                        :minFractionDigits="3"
                        :maxFractionDigits="3"
                        :class="{'p-invalid':v$.data.quantity.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                        <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'quantity', null, true)" :class="{'p-button-danger': checkModifiedField('quantity'), 'p-button-success': !checkModifiedField('quantity')}" v-if="lotProposal && lotProposal.quantity" />
                    </div>
                    <div v-if="(v$.data.quantity.$invalid && submitted) || v$.data.quantity.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.quantity.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.quantity" :label="$t('movementInstructions.quantity')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="minimumQuantity" :class="{'p-error':v$.data.minimumQuantity.$invalid && submitted}">{{$t('movementInstructions.minimumQuantity')}}</label>
                    <InputNumber 
                      :disabled="readOnly"
                      id="minimumQuantity" 
                      :minFractionDigits="3"
                      :maxFractionDigits="3"
                      v-model="data.minimumQuantity"
                      :class="{'p-invalid':v$.data.minimumQuantity.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                    <div v-if="(v$.data.minimumQuantity.$invalid && submitted) || v$.data.minimumQuantity.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.minimumQuantity.$silentErrors" :key="error.$validator">
                          {{$t(error.$message)}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.minimumQuantity" :label="$t('movementInstructions.minimumQuantity')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="maximumQuantity" :class="{'p-error':v$.data.maximumQuantity.$invalid && submitted}">{{$t('movementInstructions.maximumQuantity')}}</label>
                    <InputNumber 
                      :disabled="readOnly"
                      :minFractionDigits="3"
                      :maxFractionDigits="3"
                      id="maximumQuantity" 
                      v-model="data.maximumQuantity"
                      :class="{'p-invalid':v$.data.maximumQuantity.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" /> 
                    <div v-if="(v$.data.maximumQuantity.$invalid && submitted) || v$.data.maximumQuantity.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.maximumQuantity.$silentErrors" :key="error.$validator">
                          {{$t(error.$message)}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.maximumQuantity" :label="$t('movementInstructions.maximumQuantity')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="quantityUoMCode" :class="{'p-error':v$.data.quantityUoMCode.$invalid && submitted}">{{$t('unitofMeasureCode')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.quantityUoMCode"
                      :disabled="readOnly"
                      name="movement-instructions-uoms-product" 
                      api="masterdata/unit-of-measure-combo?scope=MovementInstructionProduct"
                      :class="{'p-invalid':v$.data.quantityUoMCode.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                    <div v-if="(v$.data.quantityUoMCode.$invalid && submitted) || v$.data.quantityUoMCode.$pending.$response">
                      <small class="p-error" v-for="error in v$.data.quantityUoMCode.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                    </div>
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.quantityUoMCode" :label="$t('unitofMeasureCode')"/>
                  </span> -->
                </div>
              </div>
            </Fieldset>
            <Fieldset class="col-12 mt-2" :legend="$t('movementInstructions.origin')">
              <div class="grid formgrid" >
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="originCountryCode" :class="{'p-error':v$.data.idOriginCountry.$invalid && submitted}">{{$t('movementInstructions.originNation')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idOriginCountry"
                      :disabled="readOnly"
                      name="countries-and-territories" 
                      api="masterdata/country-and-territory-combo"
                      :class="{'p-invalid':v$.data.idOriginCountry.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.originCountry" :label="$t('countryAndTerritory.countryAndTerritory')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="placeOfLoadingCode" :class="{'p-error':v$.data.idPlaceOfLoading.$invalid && submitted}">{{$t('movementInstructions.placeOfLoadingCode')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idPlaceOfLoading"
                    :disabled="readOnly"
                    name="countries-and-territories" 
                      api="masterdata/country-and-territory-combo"
                      :class="{'p-invalid':v$.data.idPlaceOfLoading.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.placeOfLoading" :label="$t('movementInstructions.placeOfLoadingCode')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                    <label for="portOrLocationofLoadingCode" :class="{'p-error':v$.data.idPortOrLocationOfLoading.$invalid && submitted}">{{$t('portAndLocation.movementInstrFK')}}</label>
                    <div class="p-inputgroup">
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idPortOrLocationOfLoading"
                      :disabled="readOnly"
                      name="ports-and-locations" 
                      api="masterdata/port-and-location-combo"
                      :class="{'p-invalid':v$.data.idPortOrLocationOfLoading.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'portOfLoading', null, true)" :class="{'p-button-danger': checkModifiedField('portOfLoading'), 'p-button-success': !checkModifiedField('portOfLoading')}" v-if="lotProposal && lotProposal.portOfLoading" />
                    </div>
                </div>
              </div>
            </Fieldset>
            <Fieldset class="col-12 mt-2" :legend="$t('movementInstructions.destination')">
              <div class="grid formgrid" >
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="destinationCountryCode" :class="{'p-error':v$.data.idDestinationCountry.$invalid && submitted}">{{$t('movementInstructions.destinationNation')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idDestinationCountry"
                      :disabled="readOnly"
                      name="countries-and-territories" 
                      api="masterdata/country-and-territory-combo"
                      :class="{'p-invalid':v$.data.idDestinationCountry.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.destinationCountry" :label="$t('countryAndTerritory.countryAndTerritory')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="placeofDischargeCode" :class="{'p-error':v$.data.idPlaceOfDischarge.$invalid && submitted}">{{$t('movementInstructions.placeofDischargeCode')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idPlaceOfDischarge"
                      :changeFn="onPlaceOfDischargeChange"
                      :disabled="readOnly"
                      name="countries-and-territories" 
                      api="masterdata/country-and-territory-combo"
                      :class="{'p-invalid':v$.data.idPlaceOfDischarge.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.placeOfDischarge" :label="$t('movementInstructions.placeofDischargeCode')"/>
                  </span> -->
                </div>
                <div class="col-12 lg:col-3 field">
                    <label for="portOrLocationofDischargeCode" :class="{'p-error':v$.data.idPortOrLocationOfDischarge.$invalid && submitted}">{{$t('portAndLocation.movementInstrFK')}}</label>
                    <div class="p-inputgroup">
                    <GenericCustomMasterDataAutocompleteV2
                      ref="portOfLocationOfDischargeCombo"
                      v-model="data.idPortOrLocationOfDischarge"
                      :changeFn="onPortOrLocationOfDischargeChange"
                      :disabled="readOnly"
                      name="ports-and-locations" 
                      api="masterdata/port-and-location-combo"
                      :class="{'p-invalid':v$.data.idPortOrLocationOfDischarge.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'portOfDischarge', 'port', true)" :class="{'p-button-danger': checkModifiedField('portOfDischarge'), 'p-button-success': !checkModifiedField('portOfDischarge')}" v-if="lotProposal && lotProposal.portOfDischarge"/>
                    </div>
                </div>
              </div>
            </Fieldset>
            <Fieldset class="col-12 mt-2" :legend="$t('movementInstructions.fiscalInfo')" v-if="visibilityData.transportType != constants.transportType.STOCK_TRANSFER">
            <div class="grid formgrid" >
              <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.IN">
                  <!-- <span v-if="!readOnly"> -->
                    <label for="idRegistryCustomSituation" :class="{'p-error':v$.data.idRegistryCustomSituation.$invalid && submitted}">{{$t('customsSituation.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idRegistryCustomSituation"
                      :disabled="readOnly"
                      name="customs-situations"
                      api="masterdata/custom-situation-combo"
                      :class="{'p-invalid':v$.data.idRegistryCustomSituation.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                  <!-- </span>
                  <span v-else>
                    <LabelField :value="data.customSituation" :label="$t('customsSituation.fk')"/>
                  </span> -->
              </div>
              <div class="col-12 lg:col-3 field" >
              <!-- <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT"> -->
                <!-- <span v-if="!readOnly"> -->
                  <label for="idRegistryFiscalPosition" :class="{'p-error':v$.data.idRegistryFiscalPosition.$invalid && submitted}">{{$t('fiscalPosition.fk')}}</label>
                  <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idRegistryFiscalPosition"
                    :disabled="readOnly"
                    name="fiscal-positions"
                    api="masterdata/fiscal-position-combo"
                    :class="{'p-invalid':v$.data.idRegistryFiscalPosition.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.registryFiscalPosition" :label="$t('fiscalPosition.fk')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                <!-- <span v-if="!readOnly"> -->
                  <label for="idRegistryFiscalUse" :class="{'p-error':v$.data.idRegistryFiscalUse.$invalid && submitted}">{{$t('fiscalUse.fk')}}</label>
                  <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idRegistryFiscalUse"
                    :disabled="readOnly"
                    name="fiscal-uses"
                    api="masterdata/fiscal-use-combo"
                    :class="{'p-invalid':v$.data.idRegistryFiscalUse.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.registryFiscalUse" :label="$t('fiscalUse.fk')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                <!-- <span v-if="!readOnly"> -->
                    <label for="idRegistryEnergyProductDetail" :class="{'p-error':v$.data.idRegistryEnergyProductDetail.$invalid && submitted}">{{$t('energyProduct.nC')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idRegistryEnergyProductDetail"
                      :disabled="readOnly"
                      name="energy-product-details"
                      :api="ncApi"
                      :disableStore="true"
                      ref="ncCombo"
                    :class="{'p-invalid':v$.data.idRegistryEnergyProductDetail.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.registryEnergyProduct" :label="$t('energyProduct.nC')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                <!-- <span v-if="!readOnly"> -->
                    <label for="placeofFiscalDestinationDescription" :class="{'p-error':v$.data.placeofFiscalDestinationDescription.$invalid && submitted}">{{$t('movementInstructions.destination')}}</label>
                    <InputText 
                      :disabled="readOnly"
                      id="placeofFiscalDestinationDescription" type="text" 
                      v-model="data.placeofFiscalDestinationDescription" 
                      :class="{'p-invalid':v$.data.placeofFiscalDestinationDescription.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.placeofFiscalDestinationDescription" :label="$t('movementInstructions.destination')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                    <label for="portorLocationofFiscalDestinationDescription" :class="{'p-error':v$.data.portorLocationofFiscalDestinationDescription.$invalid && submitted}">{{$t('movementInstructions.destinationPort')}}</label>
                    <div class="p-inputgroup">
                      <InputText 
                      :disabled="readOnly"
                      id="portorLocationofFiscalDestinationDescription" type="text" 
                      v-model="data.portorLocationofFiscalDestinationDescription" 
                      :class="{'p-invalid':v$.data.portorLocationofFiscalDestinationDescription.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true}" />
                      <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'portOfDischarge', 'destination', true)" :class="{'p-button-danger': checkModifiedField('portOfDischarge'), 'p-button-success': !checkModifiedField('portOfDischarge')}" v-if="lotProposal && lotProposal.portOfDischarge"/>
                    </div>
              </div>
              <div class="col-12 lg:col-3 field" v-if="visibilityData.movementDirection == constants.movementDirection.OUT">
                <!-- <span v-if="!readOnly"> -->
                    <label for="fiscalDestination">{{$t('fiscalDestination.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                      v-model="data.idFiscalDestination"
                      :disabled="true"
                      name="fiscal-destination"
                      api="masterdata/fiscal-destination-combo"
                    :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.fiscalDestination" :label="$t('fiscalDestination.fk')"/>
                </span> -->
              </div>
              <div class="col-12 lg:col-6 field" v-if="data.fiscalDestinationCode != 'EST'">
                <!-- <span v-if="!readOnly"> -->
                    <label for="idDestinationTaxWarehouse" >{{$t('taxWarehouse.fk')}}</label>
                    <div class="p-inputgroup">
                      <ResponsiveButton icon="pi pi-trash" @click="clearTaxWarehouse" class=" mt-1 "
                      :disabled="readOnly"/>
                      <InputText 
                        :disabled="true"
                        id="destinationTaxWarehouse" type="text" 
                        v-model="data.destinationTaxWarehouse" />
                      <ResponsiveButton icon="pi pi-search" @click="toggleTaxWarehouseSearch" class=" mt-1 " :disabled="readOnly"/>
                    <ResponsiveButton icon="fa-solid fa-triangle-exclamation" style="color:white" @click="openProposal($event, 'eadConsignee', null, true)" :class="{'p-button-danger': checkModifiedField('eadConsignee'), 'p-button-success': !checkModifiedField('eadConsignee')}" v-if="lotProposal && lotProposal.eadConsignee"/>

                    </div>
                <!-- </span>
                <span v-else>
                  <LabelField :value="data.destinationTaxWarehouse" :label="$t('taxWarehouse.fk')"/>
                </span> -->
              </div>
            </div>

            </Fieldset>
          </div>
        </div>
      </div>
      <Toolbar style="padding: 0;" v-if="!readOnly" >
        <template #end>
            <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="p-button-outlined p-button-sm" @click="save((!v$.$invalid))" v-if="!readOnly" :disabled="!uiPermissions('movementInstructionEditButton').isEnabled || readOnly"/>
        </template>
      </Toolbar>
  </main>
</template>
